import { render } from "./ConnectBusinessProfile.vue?vue&type=template&id=63f66a7e"
import script from "./ConnectBusinessProfile.vue?vue&type=script&lang=js"
export * from "./ConnectBusinessProfile.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__